/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostTrendByResourceCategoryWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostTrendByResourceCategoryWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostTrendByResourceCategoryWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostTrendByResourceCategoryWidgetConfiguration>): CostTrendByResourceCategoryWidgetConfiguration {
        let obj = Object.assign(new CostTrendByResourceCategoryWidgetConfiguration(), model);
        CostTrendByResourceCategoryWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostTrendByResourceCategoryWidgetConfiguration>): CostTrendByResourceCategoryWidgetConfiguration {
        if (!model) return null;
        return CostTrendByResourceCategoryWidgetConfiguration.newInstance(<CostTrendByResourceCategoryWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostTrendByResourceCategoryWidgetConfiguration) {
        if (!obj) return;

        models.CostTrendByResourceCategoryWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostTrendByResourceCategoryWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostTrendByResourceCategoryWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Granularity to aggregate data
     */
    granularity: models.TrendGranularity;

}
